import {
  apiGetChildren,
  apiApproveStudent,
  apiDeclineStudent,
  apiRemoveStudent
} from '../../common/api/profile'

const fetchChildren = () => ({
  requestPrefix: 'CHILDREN:FETCHING',
  request: () => apiGetChildren()
})

const approveChild = id => ({
  requestPrefix: 'CHILDREN:APPROVE',
  params: { id },
  request: () => apiApproveStudent({ student_id: id })
})

const declineChild = id => ({
  requestPrefix: 'CHILDREN:DECLINE',
  params: { id },
  request: () => apiDeclineStudent({ student_id: id })
})

const removeChild = (studentId, parentId) => ({
  requestPrefix: 'CHILDREN:REMOVE',
  params: { studentId, parentId },
  request: () =>
    apiRemoveStudent({ student_id: studentId, parent_id: parentId })
})

export { fetchChildren, approveChild, declineChild, removeChild }
